export default __webpack_public_path__ + "static/media/MH-Gen-AI-Small-Dark.bface87a.png";